import { datadogLogs } from '@datadog/browser-logs';

type LogContext = {
  [key: string]: string | number | boolean | null | undefined | object | unknown;
};

interface ErrorDetails {
  message: string;
  error?: Error;
  context?: LogContext;
}

export const logger = {
  error: ({ message, error, context = {} }: ErrorDetails) => {
    // Log to console without stack trace
    console.error(message);

    // Send to DataDog with full error details
    datadogLogs.logger.error(message, {
      ...context,
      error: error?.message,
      stack: error?.stack,
      source: 'browser',
    });
  },

  warn: (message: string, context: LogContext = {}) => {
    console.warn(message);
    datadogLogs.logger.warn(message, context);
  },

  info: (message: string, context: LogContext = {}) => {
    console.info(message);
    datadogLogs.logger.info(message, context);
  },
};
